"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.chatNew = chatNew;
const path = __importStar(require("path"));
const dist_1 = require("../../core/dist");
const chatNames_1 = require("./utils/chatNames");
async function chatNew(input, deps) {
    const chatsDir = !input.weaveId
        ? path.join(deps.loomRoot, 'loom', 'chats')
        : input.threadId
            ? path.join(deps.loomRoot, 'loom', input.weaveId, input.threadId, 'chats')
            : path.join(deps.loomRoot, 'loom', input.weaveId, 'chats');
    await deps.fs.ensureDir(chatsDir);
    const existingFiles = await deps.fs.readdir(chatsDir).catch(() => []);
    const scopeId = input.threadId ?? input.weaveId ?? 'global';
    // Canonical flat chat filename: chat-NNN.md (ordinal recognises legacy names too).
    const chatFilename = (0, dist_1.chatFileName)((0, dist_1.nextOrdinal)(existingFiles, 'chat'));
    const chatId = (0, dist_1.generateDocId)('chat');
    const title = input.title || `${scopeId} Chat`;
    const frontmatter = (0, dist_1.createBaseFrontmatter)('chat', chatId, title, null);
    const doc = {
        ...frontmatter,
        type: 'chat',
        status: 'active',
        content: `## ${(0, chatNames_1.getUserName)(deps.loomRoot)}\n`,
    };
    const filePath = path.join(chatsDir, chatFilename);
    await deps.saveDoc(doc, filePath);
    return { id: chatId, filePath };
}
